import type { ComparisonRun } from "./simulatorComparisonTypes";

export const STANDALONE_SIMULATOR_RUNS_STORAGE_KEY = "tessera_standalone_simulator_runs_v1";

export type StandaloneSimulatorRunsSnapshot = {
  runs: ComparisonRun[];
  brokerAccountCode: string;
  selectedRunId?: string;
  updatedAt: number;
};

export function readStandaloneSimulatorRuns(): StandaloneSimulatorRunsSnapshot | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(STANDALONE_SIMULATOR_RUNS_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") return null;
    const runs = (parsed as { runs?: unknown }).runs;
    if (!Array.isArray(runs)) return null;
    const brokerAccountCode = String((parsed as { brokerAccountCode?: unknown }).brokerAccountCode ?? "");
    const selectedRunId = (parsed as { selectedRunId?: unknown }).selectedRunId;
    return {
      runs: runs as ComparisonRun[],
      brokerAccountCode,
      selectedRunId: typeof selectedRunId === "string" ? selectedRunId : undefined,
      updatedAt: Number((parsed as { updatedAt?: unknown }).updatedAt) || Date.now(),
    };
  } catch {
    return null;
  }
}

export function writeStandaloneSimulatorRuns(snapshot: Omit<StandaloneSimulatorRunsSnapshot, "updatedAt">): void {
  if (typeof window === "undefined") return;
  try {
    const payload: StandaloneSimulatorRunsSnapshot = { ...snapshot, updatedAt: Date.now() };
    window.sessionStorage.setItem(STANDALONE_SIMULATOR_RUNS_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
}
